import React, { useState } from "react";
import axios from "../../api/axios";
import ReportFilterBar from "../../components/reports/ReportFilterBar";
import ReportTable from "../../components/reports/ReportTable";

export default function TimesheetReport() {

  const [rows, setRows] = useState([]);

  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    user: "",
    project: "",
    workItem: ""
  });

  const fetchData = async () => {

    try {

      const params = {
        startDate: filters.startDate,
        endDate: filters.endDate
      };

      if (filters.user) params.user = filters.user;
      if (filters.project) params.project = filters.project;
      if (filters.workItem) params.workItem = filters.workItem;

      const res = await axios.get("/api/reports/timesheet", {
        params
      });

      console.log("TIMESHEET RESPONSE:", res.data);

      const data =
        res.data?.rows ||
        res.data?.data ||
        res.data ||
        [];

      setRows(Array.isArray(data) ? data : []);

    } catch (err) {

      console.error("Timesheet Fetch Error:", err);
      setRows([]);

    }
  };

  const columns = [
    { field: "date", header: "Date" },
    { field: "user", header: "User" },
    { field: "project", header: "Project" },
    { field: "work_item", header: "Work Item" },
    { field: "minutes", header: "Minutes" }
  ];

  return (
    <>
      <h2>Timesheet Report</h2>

      <ReportFilterBar
        filters={[
          "startDate",
          "endDate",
          "user",
          "project",
          "workItem"
        ]}
        values={filters}
        onChange={setFilters}
        onFetch={fetchData}
      />

      <ReportTable
        columns={columns}
        rows={rows}
      />
    </>
  );
}